var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4159_22551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.38718 21.6324C5.38718 22.8446 6.379 23.8365 7.59123 23.8365H16.4074C17.6197 23.8365 18.6115 22.8446 18.6115 21.6324V8.4081H5.38718V21.6324ZM8.09817 13.786L9.65202 12.2321L11.9993 14.5684L14.3356 12.2321L15.8895 13.786L13.5532 16.1223L15.8895 18.4586L14.3356 20.0124L11.9993 17.6761L9.66304 20.0124L8.10919 18.4586L10.4455 16.1223L8.09817 13.786ZM15.8564 5.10203L14.7544 4H9.24427L8.14225 5.10203H4.28516V7.30608H19.7135V5.10203H15.8564Z",
    fill: "#D6002A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4159_22551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.9050b0a861aba33f721ba9ee4dd86f62.svg";
export { ForwardRef as ReactComponent };